import type { SelfProfileWorker, WorkerRewards } from './model';

const defaultWorker: SelfProfileWorker = {
  id: '03',
  workerId: 'A-2023-041',
  descriptor: '이정연',
  status: 'ACTIVE',
  hireDate: '2023-03-02',
  originalHireDate: '2023-03-02',
  person: { id: 'person-fixture', email: 'jungyeon.lee@example.com' },
  primaryJob: {
    id: 'job-03',
    businessTitle: 'People Partner',
    supervisoryOrganization: { id: 'people', descriptor: 'People & Culture' },
    location: { id: 'seoul', descriptor: '서울 본사' },
    manager: { id: 'manager-1', descriptor: '조혜민' },
  },
  additionalJobs: [{
    id: 'job-03-additional',
    businessTitle: 'People Operations Partner',
    supervisoryOrganization: { id: 'engineering', descriptor: 'Engineering Division' },
    location: { id: 'seoul', descriptor: '서울 본사' },
    manager: { id: 'manager-2', descriptor: '우디(박진우)' },
  }],
};

const impersonationWorkers: Record<string, SelfProfileWorker> = {
  '02': {
    id: '02', workerId: 'A0104', descriptor: '우디(박진우)', status: 'ACTIVE', hireDate: '2021-03-15', originalHireDate: '2021-03-15',
    person: { id: 'person-02', email: 'jinwoo.park@example.com', phone: '010-2104-2104' },
    primaryJob: {
      id: 'job-02', businessTitle: 'Engineering Director',
      supervisoryOrganization: { id: 'Engineering Division', descriptor: 'Engineering Division' },
      location: { id: '서울 본사', descriptor: '서울 본사' },
      manager: { id: '정성진', descriptor: '정성진' },
    },
  },
  '04': {
    id: '04', workerId: 'A0188', descriptor: '이수연', status: '휴직', hireDate: '2022-09-05', originalHireDate: '2022-09-05',
    person: { id: 'person-04', email: 'sooyeon.lee@example.com', phone: '010-2188-2188' },
    primaryJob: {
      id: 'job-04', businessTitle: 'Product Designer',
      supervisoryOrganization: { id: 'Design Team', descriptor: 'Design Team' },
      location: { id: '서울 본사', descriptor: '서울 본사' },
      manager: { id: '최지훈', descriptor: '최지훈' },
    },
  },
  '05': {
    id: '05', workerId: 'A0203', descriptor: '한도윤', status: 'ACTIVE', hireDate: '2024-01-08', originalHireDate: '2024-01-08',
    person: { id: 'person-05', email: 'doyoon.han@example.com', phone: '010-2203-2203' },
    primaryJob: {
      id: 'job-05', businessTitle: 'Growth Manager',
      supervisoryOrganization: { id: 'Business Division', descriptor: 'Business Division' },
      location: { id: '제주 지점', descriptor: '제주 지점' },
      manager: { id: '김서영', descriptor: '김서영' },
    },
  },
};

export function fixtureWorkerForViewer(workerId: string, impersonating: boolean): SelfProfileWorker {
  return impersonating ? impersonationWorkers[workerId] ?? defaultWorker : defaultWorker;
}

export const fixtureWorkerRewards: WorkerRewards = {
  worker: { id: '03', descriptor: '이정연' },
  asOf: '2026-08-15',
  contracts: [{ id: 'contract-1', contractType: '정규직 근로계약', contractStatus: 'ACTIVE', signedOn: '2023-02-20', weeklyHours: '40', effectiveFrom: '2023-03-02' }],
  compensation: [{ id: 'comp-1', compensationType: 'BASE_SALARY', currencyCode: 'KRW', payFrequency: 'MONTHLY', protected: true, effectiveFrom: '2026-01-01' }],
  benefitEnrollments: [{ id: 'benefit-1', benefitPlan: { id: 'health', descriptor: '단체상해보험' }, coverageLevel: 'EMPLOYEE', enrollmentStatus: 'ACTIVE', effectiveFrom: '2026-01-01' }],
};
